import axios, { clientContext } from './config'
import { serializeParams } from './helpers/helpers'

const apiCommunity = {
  getFeedItems (client, tag, tagId, source, category, closetOccasion, seasons, feedContentTypes, availableInMySize) {
    let params = ''
    if (client || tag || tagId || source || category || closetOccasion || seasons || feedContentTypes || availableInMySize) {
      params = '?' + serializeParams({ client, tag, tagId, source, category, closetOccasion, seasons, feedContentTypes, availableInMySize })
    }
    const url = '/api/feeditems/' + params
    return axios.get(url)
  },
  getLooks (client, shareToken) {
    let params = ''
    if (client) {
      params = '?client=' + client
      if (shareToken) {
        params += '&share=' + shareToken
      }
    }
    return axios.get('/api/looks/' + params)
  },
  getFeedItem (feedItemId) {
    return axios.get('/api/feeditems/' + feedItemId + '/')
  },
  getFeedItemComments (id) {
    return axios.get(
      '/api/feeditems/' + id + '/comments/')
  },
  getFeedItemLikes (id) {
    return axios.get(
      '/api/feeditems/' + id + '/likes/')
  },
  getClientPublicProfile (clientId, shareToken) {
    let url = '/api/clients/' + clientId + '/'
    if (shareToken) {
      url += '?share=' + shareToken
    }
    return axios.get(url)
  },
  postFeedItemReaction (feedItemId, likeData) {
    return axios.post('/api/feeditems/' + feedItemId + '/like/', likeData)
  },
  postFeedItemComment (commentData) {
    return axios.post('/api/feedcomments/', commentData)
  },
  patchFeedItemComment (commentId, commentData) {
    return axios.patch('/api/feedcomments/' + commentId + '/', commentData)
  },
  deleteFeedItemComment (feedItemCommentId) {
    return axios.delete('/api/feedcomments/' + feedItemCommentId)
  },
  patchCommunityProfile (data) {
    return axios.patch(`/api/clients/${clientContext.getUsername()}/`, data)
  },
  postLook (data) {
    return axios.post('/api/looks/', data)
  },
  patchLook (data, lookId) {
    return axios.patch('/api/looks/' + lookId + '/', data)
  },
  deleteLook (lookId) {
    return axios.delete('/api/looks/' + lookId + '/')
  },
  getLook (lookId) {
    return axios.get('/api/looks/' + lookId + '/')
  },
  getSystemTags (category) {
    return axios.get('/api/tags/?type=system&category=' + category)
  },
  getProfileImageUploadUrl () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/profile_image_upload_url`)
  },
  getImageUploadUrl () {
    return axios.get('/api/looks/image_upload_url/')
  },
  getUserFeedLikes () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/likes/`)
  },
  getFeedItemLikesAndFavorites (feedItemId) {
    return axios.get(`/api/feeditems/${feedItemId}/likes_and_favorites/`)
  },
  deleteFeedItem (feedItemId) {
    return axios.delete('/api/feeditems/' + feedItemId + '/')
  },
  postGenericFeedItem (data) {
    return axios.post('/api/genericfeeditems/', data)
  },
  deleteGenericFeedItem (genericFeedItemId) {
    return axios.delete('/api/genericfeeditems/' + genericFeedItemId + '/')
  },
  getGenericImageUploadUrl () {
    return axios.get('/api/genericfeeditems/image_upload_url/')
  }
}

export default apiCommunity
